<template>
  <div class="wt-view">
    <keep-alive :include="include" :exclude="exclude">
        <router-view v-bind="$attrs" v-if="keepAlive"></router-view>
    </keep-alive>
    <transition name="page" mode="out-in">
      <slot>
        <router-view v-bind="$attrs" v-if="!keepAlive"></router-view>
      </slot>
    </transition>
  </div>
</template>

<script>
/**
 * 路由过渡组件，基于router-view封装，用来代替router-view
 * 包含了fade过渡动画
 * @vuedoc
 * @exports base/wt-view
 */
export default {
  name: 'wt-view',
  props: {
    // 是否启用keep-alive模式
    keepAlive: {
      type: Boolean,
      default: false
    },
    // keep-alive原生属性，指定包含的组件
    include: String,
    // keep-alive原生属性，指定排除的组件
    exclude: String
  }
}
</script>

<style type="text/css">
.page-enter-active,
.page-leave-active {
  transition: opacity .2s;
}
.page-enter,
.page-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity .15s
}
.fade-enter,
.fade-leave-to {
  opacity: 0
}
</style>
